module.exports = __webpack_public_path__ + "../resources/img/ic_unlinked_p2.f7f0f411.svg";